import * as ADBinit from 'Vendor/adbmobile-chromecast';

import {log, logType} from 'Misc/log'; 

const getContext = ({
  SITEID,
  ISO_COUNTRY_CODE,
  ISO_LANGUAGE_CODE
  }) => ({
    "digitalData.environment.siteId": SITEID,
    "digitalData.environment.appType": "chromecast",
    "digitalData.environment.countryCode": ISO_COUNTRY_CODE,
    "digitalData.environment.languageCode": ISO_LANGUAGE_CODE,
    "digitalData.environment.timestamp": "",
    "digitalData.environment.versionNum": "1.0.0"
  }
);

let contextDefaultData = null;
let contextData = null;

export let ADBMobile = null;

export const initADBMobile = (config, state, debug) => {
  const ADBMobileConfig = config.adobe.config;
  
  const SITEID = config.adobe.context.siteId;
  const ISO_COUNTRY_CODE = config.adobe.context.isoCountryCode;
  const ISO_LANGUAGE_CODE = config.adobe.context.isoLanguageCode;

  contextDefaultData = getContext({ SITEID, ISO_COUNTRY_CODE, ISO_LANGUAGE_CODE }); 
  contextData = contextDefaultData;

  ADBMobile = ADBinit(ADBMobileConfig);
  
  if (debug) {
    ADBMobile.config.setDebugLogging(true);
    ADBMobile.config.setLoggerCallback(msg => {
      log(logType.LOG, 'AdobeAnalytics', msg);
    });
  }

  ADBMobile.media.setDelegate({
    getCurrentPlaybackTime() {
      return Math.floor(Math.floor(state.currentTime));
    },
    getQoSObject() {
      return ADBMobile.media.createQoSObject(0, 0, 0, 0);
    }
  });

  log(logType.LOG, "ADOBE INITIALISED");
  log(logType.LOG, ADBMobile.media);
}

export const createMediaObject = (media) => {
  const mediaMetadata = Object.assign(
    {},
    contextDefaultData,
    media.streamType === ADBMobile.media.StreamType.LIVE ? {} : {"videotype": "episode"}
  );
  contextData = mediaMetadata;

  const mediaObject = ADBMobile.media.createMediaObject(
    media.name, 
    media.analyticsId, 
    media.length, 
    media.streamType
  );

  const standardVideoMetadata = {};
  if (media.showName) {
    standardVideoMetadata[ADBMobile.media.VideoMetadataKeys.SHOW] = media.showName.toString();
  }
  if (media.seasonNumber) {
    standardVideoMetadata[ADBMobile.media.VideoMetadataKeys.SEASON] = media.seasonNumber.toString();
  }
  if (media.episodeNumber) {
    standardVideoMetadata[ADBMobile.media.VideoMetadataKeys.EPISODE] = media.episodeNumber.toString();
  }
  mediaObject[ADBMobile.media.MediaObjectKey.StandardVideoMetadata] = standardVideoMetadata;

  return mediaObject;
};

export const createAdBreakObject = ({name, pos, len}) => {
  return ADBMobile.media.createAdBreakObject(name, pos, len);
};

export const createAdObject = (ad) => {
  const adArr = ad.slot.ads.map(x => x.id);

  const adObject = ADBMobile.media.createAdObject(
    ad.id,
    ad.id,
    adArr.indexOf(ad.id),
    ad.duration
  );

  const adMetadata = {
    [ADBMobile.media.AdMetadataKeys.CREATIVE_ID]: ad.tracking.creativeId,
    [ADBMobile.media.AdMetadataKeys.ADVERTISER]: ad.tracking.adobe.advertiserName,
    [ADBMobile.media.AdMetadataKeys.CAMPAIGN_ID]: ad.tracking.adobe.campaignId,
    [ADBMobile.media.AdMetadataKeys.PLACEMENT_ID]: ad.tracking.adobe.placementId,
    ...contextDefaultData
  };

  contextData = adMetadata;

  return adObject;
};

export const trackSessionStart = (mediaObject) => {
  log(logType.INFO, `ADOBE trackSessionStart`);
  ADBMobile.media.trackSessionStart(mediaObject, { ...contextData });
};

export const trackPlay = () => {
  log(logType.INFO, `ADOBE trackPlay`);
  ADBMobile.media.trackPlay();
};

export const trackPause = () => {
  log(logType.INFO, `ADOBE trackPause`);
  ADBMobile.media.trackPause();
};

export const trackEnded = () => {
  log(logType.INFO, `ADOBE trackEnded`);
  ADBMobile.media.trackComplete();
  ADBMobile.media.trackSessionEnd();
};

export const trackExit = () => {
  log(logType.INFO, `ADOBE trackExit`);
  ADBMobile.media.trackSessionEnd();
};

export const trackSeekStart = () => {
  log(logType.INFO, `ADOBE trackSeekStart`);
  ADBMobile.media.trackEvent(
    ADBMobile.media.Event.SeekStart,
    {},
    { ...contextData }
  );
};

export const trackSeekComplete = () => {
  log(logType.INFO, `ADOBE trackSeekComplete`);
  ADBMobile.media.trackEvent(
    ADBMobile.media.Event.SeekComplete,
    {},
    { ...contextData }
  );
};


export const trackBufferStart = () => {
  log(logType.INFO, `ADOBE trackBufferStart`);
  ADBMobile.media.trackEvent(
    ADBMobile.media.Event.BufferStart,
    {},
    { ...contextData }
  );
};

export const trackBufferComplete = () => {
  log(logType.INFO, `ADOBE trackBufferComplete`);
  ADBMobile.media.trackEvent(
    ADBMobile.media.Event.BufferComplete,
    {},
    { ...contextData }
  );
};

export const trackAdBreakStart = ({name, pos, len}) => {
  log(logType.INFO, `ADOBE trackAdBreakStart`);
  ADBMobile.media.trackEvent(
    ADBMobile.media.Event.AdBreakStart,
    createAdBreakObject(name, pos, len),
    { ...contextData }
  );
};

export const trackAdBreakComplete = () => {
  log(logType.INFO, `ADOBE trackAdBreakComplete`);
  ADBMobile.media.trackEvent(
    ADBMobile.media.Event.AdBreakComplete,
    {},
    { ...contextData }
  );
};

export const trackAdStart = (ad) => {
  log(logType.INFO, `ADOBE trackAdStart`);
  ADBMobile.media.trackEvent(
    ADBMobile.media.Event.AdStart,
    createAdObject(ad),
    { ...contextData }
  );
};

export const trackAdComplete = () => {
  log(logType.INFO, `ADOBE trackAdComplete`);
  ADBMobile.media.trackEvent(
    ADBMobile.media.Event.AdComplete,
    {},
    { ...contextData }
  );
};


// WEBPACK FOOTER //
// ./src/misc/adobe-tracking/index.js